import { render, staticRenderFns } from "./CoordinationFeeDialog.vue?vue&type=template&id=71fdf2aa&scoped=true"
import script from "./CoordinationFeeDialog.vue?vue&type=script&lang=js"
export * from "./CoordinationFeeDialog.vue?vue&type=script&lang=js"
import style0 from "./CoordinationFeeDialog.vue?vue&type=style&index=0&id=71fdf2aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fdf2aa",
  null
  
)

export default component.exports